module.exports = __webpack_public_path__ + "static/flags/SC-0cef3b8efd90d178db140ff0cbe13af0.gif";